// @flow

import React from 'react';
import type { CompoundInputProps } from './CompoundInput';
import CompoundInput from './CompoundInput';
import InputApi from './InputApi';
import type { InputContextType } from './InputBase';

type FormValueType = { [string]: any };

class FormApi extends InputApi<FormValueType> {
  submit() {
    // $FlowFixMe - @TODO parametrize input type?
    return this._input.formDidSubmit();
  }
}

type FormProps = {
  id: string,
  onSubmit: FormApi => void,
  onBlur: (ev: SyntheticFocusEvent<HTMLFormElement>) => void,
} & CompoundInputProps<FormValueType, FormApi>;

export default class Form extends CompoundInput<FormValueType, string, FormProps> {
  static +blankReceivedValue: FormValueType = {};
  constructor(props: FormProps, context: InputContextType) {
    super(props, context);
    this.api = new FormApi(this);
  }
  formDidSubmit() {
    this.committedValue = this.currentValue;
    this.validate();
    if (this.validationProblems.length === 0 && typeof this.props.onSubmit === 'function') {
      this.props.onSubmit(this.api);
    }
  }

  +api: FormApi;

  static *eachCompoundValue(value: FormValueType): Iterator<[string, $Values<FormValueType>]> {
    yield* Object.entries(value);
  }

  static setCompoundValueElement(
    compoundValue: FormValueType,
    name: string,
    element: $Values<FormValueType>,
  ): FormValueType {
    return { ...compoundValue, [name]: element };
  }

  static getCompoundValueElement(compoundValue: FormValueType, name: string): any {
    return compoundValue[name];
  }

  render() {
    return (
      <form
        id={this.props.id}
        onSubmit={ev => {
          this.formDidSubmit();
          ev.preventDefault();
        }}
        onBlur={ev => {
          if (this.props.onBlur && typeof this.props.onBlur === 'function') {
            this.props.onBlur(ev);
          }
        }}
      >
        {typeof this.props.children === 'function'
          ? this.props.children(this.api)
          : this.props.children}
      </form>
    );
  }
}
